import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DynamicFormQuestion } from '@openapi';
import {
  mockCheckboxesQuestions,
  mockEditDialogQuestions,
  mockMultiCheckboxesQuestions,
  mockRadioQuestions,
} from '@share/constants-mock-database';
import {
  EditDialogComponent,
  EditDialogData,
} from '../../encompass-forms/components/edit-dialog/edit-dialog.component';
import { AppEnvironmentName } from '@share/constants';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Dev-only console helpers for opening debug dialogs from `window.__devTools`.
 * Use in non-prod browsers as `__devTools.openTestEditDialog('a')` or `'b'`.
 */
export class DevToolsService {
  private dialog = inject(MatDialog);
  private environmentService = inject(EnvironmentService);

  constructor() {
    if (
      this.environmentService.getEnvironment().envName !==
      AppEnvironmentName.PROD
    ) {
      (window as Window & { __devTools?: DevToolsService }).__devTools = this;
    }
  }

  openTestEditDialog(typeOfQuestion: string): void {
    let questionsToDialog: DynamicFormQuestion[];
    if (typeOfQuestion === 'a') {
      questionsToDialog = mockEditDialogQuestions;
    } else if (typeOfQuestion === 'b') {
      questionsToDialog = [
        ...mockCheckboxesQuestions,
        ...mockRadioQuestions,
        ...mockMultiCheckboxesQuestions,
      ];
    }
    const data: EditDialogData = {
      title: 'Patient demographic information',
      questions: questionsToDialog,
    };
    this.dialog.open(EditDialogComponent, {
      ariaLabel: 'Edit Acknowledgement Fields',
      panelClass: 'edit-dialog-panel',
      minWidth: '800px',
      maxWidth: '1000px',
      width: '90vw',
      disableClose: true,
      data,
    });
  }
}
